// Client wrapper for the Worker's /api/healthcheck endpoint.

export type HealthEntry = {
  type: string;
  status: "ok" | "nxdomain" | "timeout" | "error" | "servfail";
  records: string[];
  message?: string;
  /** AD bit — only `true` positively indicates DNSSEC validation. */
  ad?: boolean;
};

export type HealthReport = {
  domain: string;
  entries: HealthEntry[];
  findings: { level: "good" | "warn" | "info"; text: string }[];
};

export async function fetchHealthCheck(domain: string, signal?: AbortSignal): Promise<HealthReport> {
  const res = await fetch(`/api/healthcheck?domain=${encodeURIComponent(domain)}`, { signal });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error((body as any).error ?? `HTTP ${res.status}`);
  }
  return (await res.json()) as HealthReport;
}
